import sileo from 'sileo';

const RecentAccess = new sileo.Model('hqzen', 'recent-access');

const actions = {
    recordRecentAccess(_, data = {}) {
        if (!data?.object_id) return;

        const form = new FormData();
        form.append('model_type', data.model_type);
        form.append('object_id', data.object_id);

        return RecentAccess.objects.create(form);
    }
};

export default {
    namespaced: true,
    actions,
};
